import * as tslib_1 from "tslib";
import { EffectRimLightMethod } from "../methods/EffectRimLightMethod";
import { ShaderChunkBase } from "./ShaderChunkBase";
/**
 * EffectRimLightChunk provides a method to add rim lighting to a material. This adds a glow-like effect to edges of objects.
 */
var EffectRimLightChunk = (function (_super) {
    tslib_1.__extends(EffectRimLightChunk, _super);
    /**
     * Creates a new EffectEnvMapChunk.
     */
    function EffectRimLightChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    /**
     * @inheritDoc
     */
    EffectRimLightChunk.prototype._initVO = function (chunkVO) {
        chunkVO.needsNormals = true;
        chunkVO.needsView = true;
    };
    /**
     * @inheritDoc
     */
    EffectRimLightChunk.prototype._activate = function () {
        if (this._invalid) {
            var index = this._rimColorIndex;
            var data = this._shader.fragmentConstantData;
            var color = this._method.color;
            data[index] = ((color >> 16) & 0xff) / 0xff;
            data[index + 1] = ((color >> 8) & 0xff) / 0xff;
            data[index + 2] = (color & 0xff) / 0xff;
            data[index + 3] = 1;
            data[index + 4] = this._method.strength;
            data[index + 5] = this._method.power;
        }
    };
    /**
     * @inheritDoc
     */
    EffectRimLightChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var dataRegister = registerCache.getFreeFragmentConstant();
        var dataRegister2 = registerCache.getFreeFragmentConstant();
        var temp = registerCache.getFreeFragmentVectorTemp();
        var code = "";
        this._rimColorIndex = dataRegister.index * 4;
        code += "dp3 " + temp + ".x, " + sharedRegisters.viewDirFragment + ".xyz, " + sharedRegisters.normalFragment + ".xyz\n" +
            "sat " + temp + ".x, " + temp + ".x\n" +
            "sub " + temp + ".x, " + dataRegister + ".w, " + temp + ".x\n" +
            "pow " + temp + ".x, " + temp + ".x, " + dataRegister2 + ".y\n" +
            "mul " + temp + ".x, " + temp + ".x, " + dataRegister2 + ".x\n" +
            "sub " + temp + ".x, " + dataRegister + ".w, " + temp + ".x\n" +
            "mul " + targetReg + ".xyz, " + targetReg + ".xyz, " + temp + ".x\n" +
            "sub " + temp + ".w, " + dataRegister + ".w, " + temp + ".x\n";
        if (this._method.blendMode == EffectRimLightMethod.ADD) {
            code += "mul " + temp + ".xyz, " + temp + ".w, " + dataRegister + ".xyz\n" +
                "add " + targetReg + ".xyz, " + targetReg + ".xyz, " + temp + ".xyz\n";
        }
        else if (this._method.blendMode == EffectRimLightMethod.MULTIPLY) {
            code += "mul " + temp + ".xyz, " + temp + ".w, " + dataRegister + ".xyz\n" +
                "mul " + targetReg + ".xyz, " + targetReg + ".xyz, " + temp + ".xyz\n";
        }
        else {
            code += "sub " + temp + ".xyz, " + dataRegister + ".xyz, " + targetReg + ".xyz\n" +
                "mul " + temp + ".xyz, " + temp + ".xyz, " + temp + ".w\n" +
                "add " + targetReg + ".xyz, " + targetReg + ".xyz, " + temp + ".xyz\n";
        }
        return code;
    };
    return EffectRimLightChunk;
}(ShaderChunkBase));
export { EffectRimLightChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/EffectRimLightChunk.js